import { render, staticRenderFns } from "./AuthRoot.vue?vue&type=template&id=2aea3c52&scoped=true&"
import script from "./AuthRoot.vue?vue&type=script&lang=js&"
export * from "./AuthRoot.vue?vue&type=script&lang=js&"
import style0 from "./AuthRoot.vue?vue&type=style&index=0&id=2aea3c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea3c52",
  null
  
)

export default component.exports